import { render, staticRenderFns } from "./IngredientList.vue?vue&type=template&id=65cc7062&scoped=true"
import script from "./IngredientList.vue?vue&type=script&lang=js"
export * from "./IngredientList.vue?vue&type=script&lang=js"
import style0 from "./IngredientList.vue?vue&type=style&index=0&id=65cc7062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc7062",
  null
  
)

export default component.exports